import { Button, Input, message, Table } from "antd";
import { UploadOutlined } from '@ant-design/icons';
import { BaseComponent, IBaseProps, IBaseStates } from "../../components/infrastructure/baseComponent";
import { IAttachment } from "../../baseInfo/attachment/interfaces";

export interface IDocumnetsUploaderProps extends IBaseProps {
    onChange: (attachments: IAttachment[]) => void;
    attachments: IAttachment[];
    disabled?: boolean;
}

export interface IDocumnetsUploaderStates extends IBaseStates {
    attachments: IAttachment[];
}

export class DocumnetsUploader extends BaseComponent<IDocumnetsUploaderProps, IDocumnetsUploaderStates>{
    inputFile: { [key: string]: Input | null };
    whiteList: string = 'image/png,image/jpg,image/jpeg,application/pdf';
    whiteListExtensions: string[] = ".png,.jpg,.jpeg,.pdf".split(",");
    constructor(props: IDocumnetsUploaderProps) {
        super(props)
        this.state = {
            isAuthorized: true,
            loading: true,
            attachments: props.attachments,
            windowSize: window.innerWidth <= 765 ? 1 : 2
        };
        this.inputFile = {};
    }
    componentDidMount() {
        super.componentDidMount();
        this.setLoading(false);
    }
    componentWillUnmount() {
        super.componentWillUnmount();
        for (let key in this.inputFile)
            delete this.inputFile[key];
    }
    browseFile = (record: IAttachment) => {
        this.inputFile[record.RowGuid]?.input.click();
    }
    changeFile = async (event: any, record: any) => {
        let attachments = this.state.attachments;
        let fileStream = event.target.files.length ? event.target.files[0] : undefined;
        if (!fileStream || this.whiteList.split(',').indexOf(fileStream.type) === -1 || !fileStream.name || fileStream.name === '' || fileStream.name.split('.').length > 2 || fileStream.name.indexOf('\0') > -1 || this.whiteListExtensions.filter(f => fileStream.name.toLowerCase().endsWith(f)).length === 0) {
            message.error(`فایل انتخاب شده غیرمجاز است`);
            return false;
        }
        if (fileStream.size > 20971520) {
            message.error(`حداکثر حجم فایل 20 مگابایت باشد`);
            return false;
        }
        let attachment = attachments.find(a => a.RowGuid === record.RowGuid) as any;
        attachment['File'] = fileStream;
        attachment['Title'] = fileStream.name;
        this.props.onChange(attachments);
        this.setState({ attachments });
    }
    virtualRender() {
        const columns = [
            {
                title: 'شرح مدرک',
                dataIndex: 'Description',
                key: 'Description',
                width: 'auto',
                render: (_: any, record: IAttachment, __: number) => {
                    return <label className={(record as any).Required === true ? "label-required" : "label-norequired"}> {record.Description}</label >
                }
            },
            {
                title: 'نام فایل',
                dataIndex: 'Title',
                key: 'Title',
                width: 'auto',
                render: (text: any, attachment: IAttachment, _: number) => {
                    if (this.props.disabled) {
                        return <a href={attachment.Path} download={text}>{text}</a>;
                    }
                    return text;
                }
            },
            {
                title: '',
                dataIndex: 'Uploader',
                key: 'Uploader',
                width: 50,
                render: (_: any, record: IAttachment, __: number) => {
                    return (
                        <div style={{ margin: "10px 0px" }}>
                            <Button onClick={() => this.browseFile(record)} icon={<UploadOutlined style={{ verticalAlign: 'middle' }} />} style={{}} >
                                انتخاب فایل
                            </Button>
                            <Input
                                type="file"
                                hidden
                                ref={node => this.inputFile[record.RowGuid] = node}
                                onChange={e => this.changeFile(e, record)}
                                accept={this.whiteList} />
                        </div>
                    );
                }
            }
        ];

        let { attachments } = this.state;
        return (
            <>
                <Table
                    rowKey={"Description"}
                    showHeader={false}
                    columns={columns}
                    dataSource={attachments.map(a => a)}
                    bordered
                />
            </>
        );
    }
}